import { RouteComponentProps, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ProjectConfigEditComponent from '../../components/projects/ProjectConfigEditComponent';
import { RootState } from '../../modules';
import { useEffect, useState } from 'react';
import { getProjectConfig, updateProjectConfig } from '../../api/constlink';
import { Alert } from 'antd';
import { ProjectConfig } from '../../modules/projects';
interface ProjectConfigEditContainerProps {
  enterpriseId: string;
  projectId: string;
}
function ProjectConfigEditContainer({
  match,
}: RouteComponentProps<ProjectConfigEditContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const currentProject = useSelector(
    (state: RootState) => state.projects.project.data,
  );
  const [alertMsg, setAlertMsg] = useState<any>();
  const [projectConfig, setProjectConfig] = useState<ProjectConfig>();

  useEffect(() => {
    (async () => {
      const _projectConfig = await getProjectConfig({
        enterpriseId,
        projectId,
        projectConfigId: currentProject?.projectConfig.id,
      });
      setProjectConfig(_projectConfig);
    })();
  }, [enterpriseId, projectId, currentProject]);

  const onUpdate = async (config: any) => {
    try {
      await updateProjectConfig({
        enterpriseId,
        projectId,
        projectConfigId: currentProject?.projectConfig.id,
        projectConfig: {
          config,
        },
      });
      setAlertMsg({
        message: '프로젝트 설정 성공 하였습니다.',
        isError: false,
      });
    } catch (e: any) {
      setAlertMsg({ message: '프로젝트 설정 실패 하였습니다.', isError: true });
    }
  };

  return (
    <>
      {alertMsg && (
        <Alert
          message={`${alertMsg.message}`}
          type={alertMsg.isError ? 'error' : 'success'}
          showIcon
          closable
          afterClose={() => setAlertMsg(null)}
        />
      )}
      {projectConfig && (
        <ProjectConfigEditComponent
          enterpriseId={enterpriseId}
          projectId={projectId}
          projectConfig={projectConfig}
          onUpdate={onUpdate}
        />
      )}
    </>
  );
}

export default withRouter(ProjectConfigEditContainer);
